import axios from 'axios'
import qs from "qs";
import {getSSOOrNormalToken} from "@/modules/api/auth";

/**
 * get the url of the zip file that contains the backup data.
 */
const getEbookProfileUrl = async() =>{
    return callServletApi("restore");
}


/**
 * Get the last update time of the latest backup. Used for displaying time to user and to see if there is any data
 */
const getUpdateTime = async() => {

    console.log("@getUpdateTime")

    return await callServletApi("getUpdateTime");
}


/**
 * Get the core backup data of the target page
 */
const getLastPageRead = async() => {
    return callServletApi("getLastPage.do");
}

/**
 * Get the page numbers that contains bookmark, brush, note..etc of the current book.
 */
const getPagesWithHistory = async ()=> {
    return callServletApi("book");
}

/**
 * Retrieve the core backup data by page
 * @param pagenum
 * @returns {Promise<*>}
 */
const getHistoryByPage = async (pagenum) => {
    return callServletApi("page.do", {pagenum: pagenum});
}


/**
 * Retrieve remote inline exercise data
 * @param data
 * @returns {Promise<*>}
 */
const getInlineHtmlAnswers = async(data) => {
    return axios.post(`${process.env.VUE_APP_URI_MPMS_API}ebook/gethtmldata`,
        qs.stringify({
            access_token: localStorage.accessToken,
            data: JSON.stringify(data)
        }),
    )
}

/**
 * Backup local inline exercise data to remote
 * @param data
 * @returns {Promise<*>}
 */
const saveInlineHtmlAnswers = async(data) => {
    return axios.post(`${process.env.VUE_APP_URI_MPMS_API}ebook/savehtmldata`,
        qs.stringify({
            access_token: localStorage.accessToken,
            data: JSON.stringify(data)
        }),
    )
}


const backupToServer = async (backupData) => {

    //String is expected
    let formattedData = JSON.stringify(backupData);
    return callServletApi("backup", {bookdata:formattedData})
}

//TODO: check if other services use this setting, and move to a more common place
const callServletApi = (path, extraParam) => {

    let param = {
        ebookcode: localStorage.ebookcode,
        access_token:getSSOOrNormalToken()
    }

    if (extraParam) {
        param = {...param, ...extraParam};
    }

    return axios.post(`../${process.env.VUE_APP_SERVLET_PATH}/proxy/${path}`,
        qs.stringify(param),
        {
            withCredentials:true
        }
    )
}


export {
    getUpdateTime,
    getEbookProfileUrl,
    getPagesWithHistory,
    getLastPageRead,
    getHistoryByPage,
    getInlineHtmlAnswers,
    saveInlineHtmlAnswers,
    backupToServer
}

